import styled from 'styled-components';

import { theme } from '../../../../global';

export interface IPrimaryButtonStyles {
  $size?: 'default' | 'large';
  $direction?: 'column' | 'row';
  $isOutline?: boolean;
  $isRed?: boolean;
}

const getActiveColor = ({ $isRed }: Pick<IPrimaryButtonStyles, '$isRed'>) =>
  $isRed ? theme.colors.button_secondary : theme.colors.button_primary;

export const StyledPrimaryButton = styled.button<IPrimaryButtonStyles>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-direction: ${({ $direction }) => $direction ?? 'row'};
  width: ${({ $size }) => ($size === 'large' ? '100%' : 'max-content')};
  height: ${({ $size }) => ($size === 'large' ? '100%' : '56px')};
  padding: 12px 20px 12px 20px;
  border-radius: 55px;
  border: ${({ $isOutline, $isRed }) => $isOutline && `1px solid ${getActiveColor({ $isRed })}`};
  transition: transform 0.2s;
  box-shadow: ${({ $isOutline }) => !$isOutline && `0 0 15px ${theme.colors.shadow_primary}`};
  background-color: ${({ $isOutline }) =>
    $isOutline ? theme.colors.white : theme.colors.button_primary};

  text-transform: uppercase;
  font-size: 16px;
  line-height: 15px;
  color: ${({ $isOutline, $isRed }) =>
    $isOutline ? getActiveColor({ $isRed }) : theme.colors.white};

  &:hover {
    transform: scale(1.05);
  }

  &:disabled {
    transform: scale(1);
    opacity: 0.8;
    cursor: default;
  }
`;
